import type { ESignFieldPosition } from '@/components/ESign/types';

import type {
  PublicSignerFieldResponse,
  PublicSignerSignatureValue
} from '../publicSignerTypes';

import type { PublicSignerFieldDraftValue } from './types';

export function toFieldPosition(
  field: PublicSignerFieldResponse
): ESignFieldPosition {
  return {
    x: field.x,
    y: field.y,
    width: field.width,
    height: field.height,
    page: field.page_index + 1
  };
}

export function isTruthyFieldValue(value: boolean | null | undefined) {
  return value === true;
}

export function getTextFieldValue(
  value: PublicSignerFieldDraftValue | unknown
) {
  return typeof value === 'string' ? value : '';
}

export function getCheckboxFieldValue(
  value: PublicSignerFieldDraftValue | unknown
) {
  return typeof value === 'boolean' ? value : false;
}

export function getSignatureFieldValue(
  value: PublicSignerFieldDraftValue | unknown
): PublicSignerSignatureValue | null {
  if (!value || typeof value !== 'object' || !('type' in value)) {
    return null;
  }

  return value as PublicSignerSignatureValue;
}

export function isServerManagedSigningDateField(
  field: PublicSignerFieldResponse
) {
  return field.prefill_source === 'signing.date';
}

export function isFieldEditable(field: PublicSignerFieldResponse) {
  return field.is_editable && !isServerManagedSigningDateField(field);
}
